type CypressRuntime = {
  env?: (key: string) => any;
};

const getCypressVariable = (key: string) => {
  if (import.meta.env.VITE_CYPRESS_RUN !== "true") {
    return undefined;
  }
  const cypressRuntime = (
    globalThis as typeof globalThis & {
      Cypress?: CypressRuntime;
    }
  ).Cypress;
  return cypressRuntime?.env?.(key);
};

export const VITE_REACT_APP_API_GRAPHQL =
  import.meta.env.VITE_REACT_APP_API_GRAPHQL ||
  getCypressVariable("VITE_REACT_APP_API_GRAPHQL");

export const VITE_REACT_APP_ACTIVITY_EVENTS_URL = (
  import.meta.env.VITE_REACT_APP_ACTIVITY_EVENTS_URL ||
  getCypressVariable("VITE_REACT_APP_ACTIVITY_EVENTS_URL") ||
  ""
).trim();

export const VITE_REACT_APP_INTERCOM_ID =
  import.meta.env.VITE_REACT_APP_INTERCOM_ID ||
  getCypressVariable("VITE_REACT_APP_INTERCOM_ID");

export const VITE_NODE_ENV = import.meta.env.VITE_NODE_ENV || "local";

export const VITE_PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL || "";

export const VITE_REACT_APP_PUBLIC_S3 =
  import.meta.env.VITE_REACT_APP_PUBLIC_S3 ||
  getCypressVariable("VITE_REACT_APP_PUBLIC_S3");

export const VITE_REACT_APP_MIXPANEL_ID =
  import.meta.env.VITE_REACT_APP_MIXPANEL_ID ||
  getCypressVariable("VITE_REACT_APP_MIXPANEL_ID");

export const VITE_REACT_APP_MELA_ENV: "local" | "dev" | "prod" =
  import.meta.env.VITE_REACT_APP_MELA_ENV ||
  getCypressVariable("VITE_REACT_APP_MELA_ENV");

export const VITE_REACT_APP_AUTH0_AUDIENCE =
  import.meta.env.VITE_REACT_APP_AUTH0_AUDIENCE ||
  getCypressVariable("VITE_REACT_APP_AUTH0_AUDIENCE");

export const VITE_REACT_APP_AUTH0_DOMAIN =
  import.meta.env.VITE_REACT_APP_AUTH0_DOMAIN ||
  getCypressVariable("VITE_REACT_APP_AUTH0_DOMAIN");

export const VITE_REACT_APP_AUTHENTIK_DOMAIN =
  import.meta.env.VITE_REACT_APP_AUTHENTIK_DOMAIN ||
  getCypressVariable("VITE_REACT_APP_AUTHENTIK_DOMAIN");

export const VITE_REACT_APP_AUTHENTIK_CLIENT_ID =
  import.meta.env.VITE_REACT_APP_AUTHENTIK_CLIENT_ID ||
  getCypressVariable("VITE_REACT_APP_AUTHENTIK_CLIENT_ID");

export const VITE_REACT_APP_AUTH0_CLIENT_ID =
  import.meta.env.VITE_REACT_APP_AUTH0_CLIENT_ID ||
  getCypressVariable("VITE_REACT_APP_AUTH0_CLIENT_ID");

export const VITE_REACT_APP_WS_GRAPHQL =
  import.meta.env.VITE_REACT_APP_WS_GRAPHQL ||
  getCypressVariable("VITE_REACT_APP_WS_GRAPHQL");

export const VITE_REACT_APP_STRIPE_PUBLIC_KEY =
  import.meta.env.VITE_REACT_APP_STRIPE_PUBLIC_KEY ||
  getCypressVariable("VITE_REACT_APP_STRIPE_PUBLIC_KEY");

export const VITE_SSL = import.meta.env.VITE_SSL || false;

export const VITE_REACT_APP_GOOGLE_API_KEY =
  import.meta.env.VITE_REACT_APP_GOOGLE_API_KEY ||
  getCypressVariable("VITE_REACT_APP_GOOGLE_API_KEY");

export const VITE_REACT_APP_LOG_NETWORK_ENABLED =
  import.meta.env.VITE_REACT_APP_LOG_NETWORK_ENABLED || false;

export const VITE_REACT_APP_LOG_CONSOLE_ENABLED =
  import.meta.env.VITE_REACT_APP_LOG_CONSOLE_ENABLED || false;

export const VITE_REACT_APP_LOG_LEVEL =
  import.meta.env.VITE_REACT_APP_LOG_LEVEL || "LOG";

export const VITE_REACT_APP_TUS_ENDPOINT =
  import.meta.env.VITE_REACT_APP_TUS_ENDPOINT ||
  getCypressVariable("VITE_REACT_APP_TUS_ENDPOINT");
export const VITE_REACT_APP_SENTRY_DSN =
  import.meta.env.VITE_REACT_APP_SENTRY_DSN || "";
